import React, { createContext, useEffect, useState } from "react";
import axios from "axios";
import all_product from "../Components/Assets/all_product";

export const ShopContext = createContext(null);

const ShopContextProvider = (props) => {

  const [products,setProducts] = useState([]);
  const [discountCode, applyDiscount] = useState(null);
  
  const getDefaultCart = () => {
    let cart = {};
    for (let i = 0; i < 300; i++) {
      cart[i] = 0;
    }
    return cart;
  };

  const [cartItems, setCartItems] = useState(getDefaultCart());

  useEffect(() => {
    axios.get('https://shopper-e-commerce-project-xi55.vercel.app/products') 
      .then((res) => setProducts(res.data.length > 0 ? res.data : all_product))
      .catch((err) => {
        console.warn("Backend failed, using local fallback data", err);
        setProducts(all_product);
      });

    if(localStorage.getItem("auth-token")) {
      axios.post('https://shopper-e-commerce-project-xi55.vercel.app/getcart', {}, {
        headers: {
          Accept: 'application/form-data',
          'auth-token': `${localStorage.getItem("auth-token")}`,
          'Content-Type': 'application/json',
        }
      })
      .then((res) => setCartItems(res.data))
      .catch((err) => {
         console.warn("Cart context error:", err);
         localStorage.removeItem("auth-token");
      });
    }
  }, []);
  
  const getTotalCartAmount = () => {
    let totalAmount = 0;
    let subTotal = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        let itemInfo = products.find((product) => product.id === Number(item));
        if (itemInfo) {
          let itemTotal = cartItems[item] * itemInfo.new_price;
          subTotal += itemTotal;
          
          let itemDiscount = 0;
          if (discountCode && discountCode.type === itemInfo.category) {
            itemDiscount = itemTotal * discountCode.value;
          }
          totalAmount += (itemTotal - itemDiscount);
        }
      }
    }

    if (discountCode) {
      if (discountCode.type === 'total' && subTotal >= discountCode.threshold) {
        totalAmount = subTotal * (1 - discountCode.value);
      } else if (discountCode.type === 'flat') {
        totalAmount = subTotal > 0 ? Math.max(0, subTotal - discountCode.value) : 0;
      }
    }
    
    return Math.floor(totalAmount);
  };

  const getTotalCartItems = () => {
    let totalItem = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        totalItem += cartItems[item];;
      }
    }
    return totalItem;
  };

  const addToCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
    if(localStorage.getItem("auth-token")) {
      axios.post('https://shopper-e-commerce-project-xi55.vercel.app/addtocart', {itemId: itemId}, {
        headers: {
          Accept: 'application/form-data',
          'auth-token': `${localStorage.getItem("auth-token")}`,
          'Content-Type': 'application/json',
        }
      })
      .then((resp) => console.log(resp.data))
      .catch((err) => {
        alert("Your session encountered an error (likely due to switching databases). Please log in again.");
        localStorage.removeItem("auth-token");
        window.location.replace('/login');
      });
    }
  };

  const removeFromCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
    if(localStorage.getItem("auth-token")) {
      axios.post('https://shopper-e-commerce-project-xi55.vercel.app/removefromcart', { itemId }, {
        headers: {
          Accept: 'application/form-data',
          'auth-token': `${localStorage.getItem("auth-token")}`,
          'Content-Type': 'application/json',
        }
      })
      .then((res) => console.log(res.data))
      .catch((err) => {
        localStorage.removeItem("auth-token");
        window.location.replace('/login');
      });
    }
  };

  const contextValue = {products, getTotalCartItems, cartItems, addToCart, removeFromCart, getTotalCartAmount, discountCode, applyDiscount };
  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;
